import { combineReducers } from "redux";
import login from "containers/login/reducer";
import dashboard from "containers/dashboard/reducer";
import payables from "containers/payables/reducer";
import receivables from "containers/receivables/reducer";
import orderbacklog from "containers/backlog/reducer";
import purchaseorder from "containers/purchaseOrder/reducer";
import customerList from "containers/customers/listnew/reducer";
import customerDetails from "containers/customers/reducer";
import workflow from "containers/settings/receivables/ARworkflow/reducer";
import disputeWorkflow from "containers/disputeDeduction/workflow/reducer";
import settings from "containers/settings/reducer";
import compareScenarios from "containers/reports/CompareScenarios/reducer";
import settingsUser from "containers/settings/company/usersList/reducer";
import reports from "containers/reports/reducers";
import auth from "reducers/auth";
import global from "reducers/global";
import skipArEmail from "containers/settings/receivables/reducer";
import payablesInvoicingFields from "containers/settings/payables/reducer";
import user from "reducers/user";
import activity from "containers/analytics-report/Activity/reducers";
import paymentAnalyticsDetails from "containers/analytics-report/Payments/reducer";
import autopayAccountsDetails from "containers/analytics-report/AutopayAccounts/reducer";
import bankBalanceReportDetails from "containers/analytics-report/BankBalance/reducer";
import helpPageResources from "containers/help/reducer";
import journalEntries from "containers/journal-entries/reducer";
import vendorListing from "containers/vendors/list/reducer";
import globalNotesList from "containers/analytics-report/Notes/reducer";
import smsList from "containers/analytics-report/Sms/reducer";
import carrierActivity from "containers/analytics-report/CarrierActivity/reducer";
import invoicingPortal from "containers/vendors/invoicing-portal/reducer";
import phoneCall from "containers/settings/profile/makePhoneCall/reducer";
import reportsCallList from "containers/analytics-report/Phone/reducer";
import vendorDetails from "containers/vendors/details/reducer";
import emailLogList from "containers/analytics-report/Email/reducer";
import filesReportList from "containers/analytics-report/Files/reducer";
import reportsAuditLogs from "containers/analytics-report/Audit/reducer";
import guestUserData from "containers/guest_checkout/reducer";
import disputeManagement from "containers/disputeDeduction/reducer";
import lockboxState from "containers/lockbox/reducer";
import remoteDepositState from "containers/remote_deposit/reducer";
import payAdminManagement from "containers/support/PayAdminManagement/reducer";
import creditCustomerList from "containers/credit-management/customers/reducer";
import creditCustomerDetail from "containers/credit-management/customers/detail/reducer";
import creditApprovals from "containers/credit-management/approvals/reducer";
import creditAlerts from "containers/credit-management/alerts/reducer";
import creditDashboard from "containers/credit-management/dashboard/reducer";
import creditOpenItems from "containers/credit-management/customers/detail/openItemsReducer";
import creditRiskClasses from "containers/credit-management/settings/risk-classes/reducer";
import collectorInboxList from "containers/CollectorsInbox/Inbox/reducer";
import collectorInboxDetails from "containers/CollectorsInbox/InboxDetails/reducer";
import deductionManagement from "containers/deduction/reducer";
import ssoSessionExpired from "reducers/ssoSessionExpired";
import aiSupportBot from "reducers/aiSupportBot";
import collectionsOrchestrationEngine from "containers/settings/receivables/CollectionsOrchestrationEngine/reducer";
import performanceTests from "containers/performance-tests/reducer";

// Combine all reducers.
const appReducer = combineReducers({
  auth,
  user,
  login,
  smsList,
  reports,
  payables,
  activity,
  settings,
  workflow,
  disputeWorkflow,
  dashboard,
  phoneCall,
  skipArEmail,
  receivables,
  emailLogList,
  filesReportList,
  orderbacklog,
  settingsUser,
  customerList,
  purchaseorder,
  guestUserData,
  vendorDetails,
  vendorListing,
  journalEntries,
  disputeManagement,
  reportsCallList,
  carrierActivity,
  invoicingPortal,
  globalNotesList,
  customerDetails,
  compareScenarios,
  reportsAuditLogs,
  helpPageResources,
  payablesInvoicingFields,
  paymentAnalyticsDetails,
  autopayAccountsDetails,
  bankBalanceReportDetails,
  lockboxState,
  remoteDepositState,
  payAdminManagement,
  creditCustomerList,
  creditCustomerDetail,
  creditApprovals,
  creditAlerts,
  creditDashboard,
  creditOpenItems,
  creditRiskClasses,
  collectorInboxList,
  collectorInboxDetails,
  deductionManagement,
  ssoSessionExpired,
  aiSupportBot,
  collectionsOrchestrationEngine,
  performanceTests,
  ...global,
});

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  // eslint-disable-next-line no-param-reassign
  if (action.type === "DESTROY_SESSION") state = undefined;

  return appReducer(state, action);
};

export default rootReducer;
